// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Campaigns_establishments__34XQ6","header":"Campaigns_header__2hjbk","tableHeader":"Campaigns_tableHeader__2mpDf"};